
const ACCENT = "var(--btn-bg)";

export const dropdownSelectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: 8,
    border: "1px solid #e8edf5",
    background: "#f8f9fe",
    minHeight: 34,
    height: 34,
    fontSize: 13,
    boxShadow: "none",
    "&:hover": {
      borderColor: state.isFocused ? ACCENT : "#e8edf5",
    },
  }),

  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),

  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: 34,
  }),

  menu: (base) => ({
    ...base,
    minWidth: 340,
    borderRadius: 10,
    overflow: "hidden",
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 2000,
  }),

  option: (base, state) => ({
    ...base,
    fontSize: 13,
    cursor: "pointer",
    background: state.isSelected
      ? ACCENT
      : state.isFocused
        ? "#e6f1f8"
        : "#fff",
    color: state.isSelected ? "#fff" : "#1f2937",
  }),
};
